import { getConfiguration } from '../../data/utils';
import { useFetchNew } from '../../data/fetch/useFetch';
import { parseAutocompleteData } from '../../data/parseAutocompleteData';


export default function SearchDataFetcher(props) {
    const conf = getConfiguration();

    const [isLoading, isError, data] = useFetchNew(conf.api.getAutocompleteData, { live: false }, (data) =>
        parseAutocompleteData(data, false)
    );

    if (isLoading || isError) {
        return null;
        // TODO handle error
    }

    return props.renderItem(data);
}
